import { Outlet, useNavigate, useNavigation } from "react-router-dom";
import SidebarComponent from "../../components/sidebar/SidebarComponent";
import { useState } from "react";
import BottomBarComponent from "../../components/sidebar/BottomBarComponent";
import { Button } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../lib/hook";
import { logoutAction } from "../../lib/store";
import { localStorageService } from "../../service/localStorage.service";

const DashboardLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col  ">
      <div className="p-2">
        <header className="h-fit border-b bg-white w-full flex justify-between items-center p-2 rounded-xl shadow-md">
          <Button
          size="large"
            className=""
            onClick={() => setIsOpen(!isOpen)}
            icon={
              <i
                className={`fa-solid ${
                  isOpen ? "fa-xmark" : "fa-bars"
                } `}
              ></i>
            }
          />
          <div className="flex items-center text-2xl font-semibold text-gray-900">
            <img
              className="w-11 h-11 mr-2"
              src="/ms-icon-310x310.png"
              alt="logo"
            />
            <p className="font-bold text-xl text-red-600">
              BH Travel
            </p>
          </div>

          <Button
            size="large"
            onClick={() => {
              localStorageService.clear();
              dispatch(logoutAction());
              navigate("/auth/login");
            }}
            icon={<LogoutOutlined />}
          />
        </header>
      </div>

      {/* MAIN */}
      <main className="flex flex-1 bg-gray-200 mb-[80px] md:mb-0">
        {/* Sidebar */}
        <SidebarComponent
          isOpen={isOpen}
          setIsOpen={() => setIsOpen(!isOpen)}
        />

        {/* Content */}
        <div className="flex-1 p-2">
          <Outlet />
        </div>
      </main>
      <BottomBarComponent />
    </div>
  );
};

export default DashboardLayout;
